// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // hostUrl:"http://localhost:3000",
  // hostUrl2:"http://localhost:3000",
  // hostUrl: "https://socket.oneqlik.in",
  // hostUrl2: "https://socket.oneqlik.in",
  //   hostUrl:"https://www.oneqlik.in",
  //  hostUrl2:"https://www.oneqlik.in",
   hostUrl:"http://wetrack.pk",
   hostUrl2:"http://wetrack.pk",
  socket5000: "",
  showLandingpageMenu: ["www.drsupergps.com", "www.vpngps.tech", "www.globaltechnohelp.com", "www.tracktive.in", "www.sohamshakti.in", "www.spygpstrack.com", "www.mtelematics.in", "www.dstrackingsolutions.com", "www.vctrack.in", "www.hltgps.in", "www.xcelgps.com"]


};

// "www.drsupergps.com","www.globaltechnohelp.com","www.sohamshakti.in","www.spygpstrack.com","www.mtelematics.in"






// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/environments/environment.ts